export default "__VITE_ASSET__LEEDRFvd__"